import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: {},
    };
  }
  componentDidMount() {}
  componentWillReceiveProps(next) {
    this.setState({ msg: next.message });
  }
  handleChange = name => event => {
    this.setState({
      msg: {
        ...this.state.msg,
        [name]: event.target.value,
      },
    });
  };
  render() {
    const { msg } = this.state;
    return (
      <div style={{ padding: '30px' }}>
        <Link to="/edit">Отправить сообщение</Link>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/screens/Home.js